export enum CarouselMode {
  FIXED = 'fixed',
  STRETCHED = 'stretched',
}
